import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { getAvatarUrlWithFallback } from '../../utils/avatarUtils';
import { ChatConfigProvider, createWhisperVoiceConfig } from '@contentgrowth/llm-service/ui/react';
import { apiClient } from '../../app/api/client';

export const ChatConfigWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user } = useAuth();

    const handleVoiceStart = React.useCallback(() => console.log('Global voice started'), []);
    const handleVoiceEnd = React.useCallback(() => console.log('Global voice ended'), []);

    const handleAudioCapture = React.useCallback(async (blob: Blob) => {
        const formData = new FormData();
        formData.append('audio', blob, 'recording.webm');
        // Use apiClient to ensure auth headers/cookies and interceptors are used
        const { data } = await apiClient.post('/api/speech/transcribe', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return data.text;
    }, []);

    const chatConfig = React.useMemo(() => {
        console.log('[ChatConfigWrapper] Recalculating config. User present:', !!user, 'VoiceEnabled:', !!user?.settings?.voiceTranscription);
        return {
            user: {
                avatarUrl: user ? getAvatarUrlWithFallback(user.photoURL) : undefined,
                name: user?.displayName || user?.email || 'User',
            },
            voice: {
                enabled: true,
                config: {
                    mode: 'custom' as const,
                    onAudioCapture: handleAudioCapture,
                    onVoiceStart: handleVoiceStart,
                    onVoiceEnd: handleVoiceEnd,
                }
            }
        };
    }, [user, handleAudioCapture, handleVoiceStart, handleVoiceEnd]);

    return (
        <ChatConfigProvider config={chatConfig}>
            {children}
        </ChatConfigProvider>
    );
};
